var _desc, _defs, _rect, _ellipse, _ellipse2, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeadershipLadder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1449,
    height: 930,
    viewBox: "0 155 1449 930",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "\u524D\u54E8 AI \u9886\u5BFC\u529B\u6A21\u578B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "\u4E94\u5C42\u9886\u5BFC\u529B\u4E0E\u56DB\u9636\u6210\u719F\u5EA6\u9636\u68AF\u56FE\uFF0C\u5305\u542B AI \u8C0B\u52BF\u3001AI \u6CBB\u7406\u3001AI \u5E26\u961F\u3001AI \u5171\u751F\u3001AI \u501F\u529B\u4EE5\u53CA\u5168\u5458 AI \u57FA\u7840\u80FD\u529B\u5E95\u5EA7\u3002")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbfbff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#f6f2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#edf2ff"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "centerGlow",
    cx: "50%",
    cy: "42%",
    r: "63%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f2edff",
    stopOpacity: 0.72
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d6d8ff",
    stopOpacity: 0.08
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "floorGlow",
    cx: "48%",
    cy: "92%",
    r: "54%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.92
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c7b8ff",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d7ff2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dbcfff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#8d73ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4830ce"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step2",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ac8bf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#6d45e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1f19b7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step3",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8f61ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#552fe0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1612a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step4",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7447e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#3c20d5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0e0b9f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "step5",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.2
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7540ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#3e18d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#130a9e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "base",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0.1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#f4f0ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6dfff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "pill",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7c40f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#5229df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3419c4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "iconBubble",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f6f3ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ded4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nodeBubble",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9272ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#7054ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5030d1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "circuitLine",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#d4cdf8",
    stopOpacity: 0.56
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "dotField",
    width: 15,
    height: 15,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2,
    fill: "#ffffff",
    opacity: 0.78
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softShadow",
    x: "-15%",
    y: "-20%",
    width: "130%",
    height: "160%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 9,
    stdDeviation: 9,
    floodColor: "#2b1ea6",
    floodOpacity: 0.28
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stepShadow",
    x: "-12%",
    y: "-22%",
    width: "124%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 12,
    stdDeviation: 9,
    floodColor: "#2811a5",
    floodOpacity: 0.33
  })), /*#__PURE__*/React.createElement("filter", {
    id: "bubbleShadow",
    x: "-40%",
    y: "-40%",
    width: "180%",
    height: "180%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 7,
    floodColor: "#3618a9",
    floodOpacity: 0.28
  })), /*#__PURE__*/React.createElement("filter", {
    id: "textLift",
    x: "-2%",
    y: "-20%",
    width: "104%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 2,
    stdDeviation: 1.3,
    floodColor: "#241188",
    floodOpacity: 0.24
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .font { font-family: \"Microsoft YaHei\", \"PingFang SC\", \"Noto Sans CJK SC\", \"Noto Sans SC\", sans-serif; }\r\n      .title { font-size: 76px; font-weight: 900; fill: #11117c; letter-spacing: 7px; }\r\n      .subtitle { font-size: 31px; font-weight: 700; fill: #4b3e91; letter-spacing: 4px; }\r\n      .step-title { font-size: 34px; font-weight: 900; fill: #fff; letter-spacing: 1px; }\r\n      .step-copy { font-size: 25px; font-weight: 500; fill: #fff; letter-spacing: .5px; }\r\n      .right-title { font-size: 24px; font-weight: 900; fill: #0c0b78; letter-spacing: .5px; }\r\n      .right-copy { font-size: 17px; font-weight: 700; fill: #2d2683; }\r\n      .dash { stroke: #bca9ff; stroke-width: 2; stroke-dasharray: 8 7; opacity: .68; }\r\n      .circuit { fill: none; stroke: url(#circuitLine); stroke-width: 1.4; stroke-linecap: round; stroke-linejoin: round; }\r\n      .circuit-node { fill: #fff; opacity: .85; }\r\n    "), /*#__PURE__*/React.createElement("symbol", {
    id: "i-telescope",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 30,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.4,
    strokeDasharray: "7 9",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 26,
    r: 3.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 21,
    r: 3.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 49,
    r: 3.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 48,
    r: 3.2,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32 49 20l5 12-25 12Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 47h17M37 42 28 58M39 43l11 15",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 25,
    r: 8,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-shield-grid",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 9 58 19v17c0 15-9.4 25.7-22 31-12.6-5.3-22-16-22-31V19Z",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 27,
    width: 24,
    height: 25,
    rx: 2.5,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27v25M36 27v25M42 27v25M24 33h24M24 40h24M24 47h24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 21v8M36 19v8M43 21v8M29 52v6M36 52v8M43 52v6",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.6,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-team-ai",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 20,
    r: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 42,
    r: 7,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 42,
    r: 7,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 45,
    r: 13,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("text", {
    x: 36,
    y: 50,
    textAnchor: "middle",
    className: "font",
    fontSize: 12,
    fontWeight: 900,
    fill: "#fff"
  }, "AI"), /*#__PURE__*/React.createElement("path", {
    d: "M25 37c2-5 5.7-8 11-8s9.2 3 11 8M27 47H18M45 47h9M23 36l-5-7M49 36l5-7M36 31v-8",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 29,
    r: 3.6,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 29,
    r: 3.6,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.5
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-human-network",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 21,
    r: 10,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 63V47c0-8 6-14 13-14s13 6 13 14v16",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 45h-7v14h7M54 42h8M54 51h8M54 60h8M17 38h-8v14",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 45,
    r: 3,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 42,
    r: 3,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 51,
    r: 3,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 60,
    r: 3,
    fill: "#fff",
    stroke: "currentColor",
    strokeWidth: 2.4
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-wand-ai",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 58 45 31",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 25 51 37M47 15l3 8 8 3-8 3-3 8-3-8-8-3 8-3ZM23 21l2 6 6 2-6 2-2 6-2-6-6-2 6-2ZM56 9l1.8 5 5 1.8-5 1.8-1.8 5-1.8-5-5-1.8 5-1.8Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 46,
    width: 22,
    height: 20,
    rx: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("text", {
    x: 54,
    y: 61,
    textAnchor: "middle",
    className: "font",
    fontSize: 12,
    fontWeight: 900,
    fill: "#fff"
  }, "AI")), /*#__PURE__*/React.createElement("symbol", {
    id: "i-temple",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 9 62 24H10Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 28h46M20 58h40M15 64h50M23 33v22M35 33v22M47 33v22M59 33v22",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-rising",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 55h9V39h-9Zm17 0h9V30h-9Zm17 0h9V20h-9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 27c10 1 19-2 27-12l5 6 13-14",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 7v14H45",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-network",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 5.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 5.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 20,
    r: 5.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 56,
    r: 5.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 5.5,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 25 31 31M47 25l-6 6M25 51l6-6M47 51l-6-6M36 30V17M36 42v13M30 36H17M42 36h13",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-bars",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 55h8V39h-8Zm16 0h8V30h-8Zm16 0h8V20h-8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 58h50M17 25v9M34 18v9M51 12v9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("symbol", {
    id: "i-user",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 25,
    r: 11,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 59c3.2-13 12-20 18-20s14.8 7 18 20Z",
    fill: "#fff"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1449,
    height: 1085,
    fill: "url(#bg)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 704,
    cy: 466,
    rx: 610,
    ry: 455,
    fill: "url(#centerGlow)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 719,
    cy: 998,
    rx: 662,
    ry: 122,
    fill: "url(#floorGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M0 172h31l12-12h79l23 23v45l20 20h87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M0 260h89l29 29h104l36-36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M75 0v72l69 69v35l25 25h49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M182 0v78l14 13h77l35 35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M0 344h73l47 47v44"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M20 140h120"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 43,
    cy: 140,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 143,
    cy: 140,
    r: 8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 263,
    cy: 91,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 308,
    cy: 136,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 219,
    cy: 191,
    r: 6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 119,
    cy: 358,
    r: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 555,
    width: 118,
    height: 100,
    fill: "url(#dotField)",
    opacity: 0.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.73
  }, /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M1449 1h-72l-88 87v61l-20 20h-144l-65 65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M1449 164h-133l-21 20h-54l-32-32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M1449 270h-79l-49-49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "circuit",
    d: "M1126 148h-44l-20 20v78"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 1062,
    cy: 208,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 1297,
    cy: 184,
    r: 7
  }), /*#__PURE__*/React.createElement("circle", {
    className: "circuit-node",
    cx: 1317,
    cy: 164,
    r: 7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1353,
    y: 25,
    width: 96,
    height: 96,
    fill: "url(#dotField)",
    opacity: 0.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 704,
    cy: 979,
    rx: 632,
    ry: 82
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 704,
    cy: 980,
    rx: 560,
    ry: 64
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 704,
    cy: 981,
    rx: 466,
    ry: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 905C207 824 334 939 526 916c205-25 365-121 577-86 155 26 235 93 449 51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 953C236 893 383 971 593 956c205-15 331-86 533-58 181 26 246 60 449 35"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "font"
  }, /*#__PURE__*/React.createElement("line", {
    className: "dash",
    x1: 856,
    y1: 281,
    x2: 1153,
    y2: 281
  }), /*#__PURE__*/React.createElement("line", {
    className: "dash",
    x1: 926,
    y1: 410,
    x2: 1153,
    y2: 410
  }), /*#__PURE__*/React.createElement("line", {
    className: "dash",
    x1: 976,
    y1: 540,
    x2: 1153,
    y2: 540
  }), /*#__PURE__*/React.createElement("line", {
    className: "dash",
    x1: 1017,
    y1: 670,
    x2: 1153,
    y2: 670
  }), /*#__PURE__*/React.createElement("line", {
    className: "dash",
    x1: 1056,
    y1: 801,
    x2: 1153,
    y2: 801
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#stepShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393 214H837c23 0 36 9 41 31l19 80c4 17-8 31-28 31H361c-20 0-32-14-28-31l20-80c5-22 18-31 40-31Z",
    fill: "url(#step5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 347H889c23 0 36 9 41 31l20 80c4 18-8 31-28 31H313c-20 0-32-13-28-31l20-80c5-22 18-31 38-31Z",
    fill: "url(#step4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 476H942c23 0 36 9 41 31l20 81c4 17-8 31-28 31H260c-20 0-32-14-28-31l20-81c5-22 18-31 39-31Z",
    fill: "url(#step3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 608H991c23 0 36 9 41 31l20 82c4 17-8 31-28 31H213c-20 0-32-14-28-31l20-82c5-22 18-31 39-31Z",
    fill: "url(#step2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 739H1033c24 0 38 10 43 32l20 82c4 18-9 31-29 31H167c-20 0-33-13-29-31l21-82c5-22 18-32 41-32Z",
    fill: "url(#step1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 870H1072c25 0 43 12 47 35l13 79c3 20-12 33-35 33H119c-23 0-38-13-35-33l13-79c4-23 17-35 37-35Z",
    fill: "url(#base)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.65,
    fill: "none",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M393 218H837c23 0 31 9 35 24",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343 351H889c23 0 31 9 35 24",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291 480H942c23 0 31 9 35 24",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244 612H991c23 0 31 9 35 24",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200 743H1033c23 0 32 9 36 24",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 874H1072c25 0 37 10 41 29",
    stroke: "#ffffff",
    strokeWidth: 5
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("rect", {
    x: 353,
    y: 345,
    width: 539,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 475,
    width: 626,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254,
    y: 605,
    width: 735,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 736,
    width: 820,
    height: 6,
    rx: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 867,
    width: 943,
    height: 8,
    rx: 4
  })), /*#__PURE__*/React.createElement("g", {
    color: "#6748e8",
    filter: "url(#bubbleShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 454,
    cy: 284,
    r: 46,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-telescope",
    x: 420,
    y: 250,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436,
    cy: 415,
    r: 46,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-shield-grid",
    x: 402,
    y: 381,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 547,
    r: 46,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-team-ai",
    x: 381,
    y: 513,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 390,
    cy: 677,
    r: 46,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-human-network",
    x: 356,
    y: 643,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368,
    cy: 807,
    r: 46,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-wand-ai",
    x: 334,
    y: 773,
    width: 68,
    height: 68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 935,
    r: 47,
    fill: "url(#iconBubble)",
    stroke: "#ffffff",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-temple",
    x: 305,
    y: 900,
    width: 70,
    height: 70
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#textLift)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 531,
    y: 275,
    className: "step-title"
  }, "\u7B2C\u4E94\u5C42\uFF1A AI \u8C0B\u52BF"), /*#__PURE__*/React.createElement("text", {
    x: 531,
    y: 314,
    className: "step-copy"
  }, "\u6D1E\u5BDF AI \u91CD\u5851\u7684\u5916\u90E8\u4E16\u754C"), /*#__PURE__*/React.createElement("text", {
    x: 522,
    y: 406,
    className: "step-title"
  }, "\u7B2C\u56DB\u5C42\uFF1A AI \u6CBB\u7406"), /*#__PURE__*/React.createElement("text", {
    x: 522,
    y: 445,
    className: "step-copy"
  }, "\u7BA1\u7406\u667A\u80FD\u4F53\u4E0E\u6570\u5B57\u5458\u5DE5"), /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 536,
    className: "step-title"
  }, "\u7B2C\u4E09\u5C42\uFF1A AI \u5E26\u961F"), /*#__PURE__*/React.createElement("text", {
    x: 506,
    y: 575,
    className: "step-copy"
  }, "\u5E26\u9886\u201C\u4EBA+AI\u201D\u6DF7\u5408\u56E2\u961F"), /*#__PURE__*/React.createElement("text", {
    x: 494,
    y: 666,
    className: "step-title"
  }, "\u7B2C\u4E8C\u5C42\uFF1A AI \u5171\u751F"), /*#__PURE__*/React.createElement("text", {
    x: 494,
    y: 706,
    className: "step-copy"
  }, "\u6210\u4E3A\u4EBA\u673A\u534F\u540C\u7684\u590D\u5408\u7BA1\u7406\u8005"), /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 795,
    className: "step-title"
  }, "\u7B2C\u4E00\u5C42\uFF1A AI \u501F\u529B"), /*#__PURE__*/React.createElement("text", {
    x: 481,
    y: 835,
    className: "step-copy"
  }, "\u628A AI \u7528\u8FDB\u9AD8\u9891\u7BA1\u7406\u52A8\u4F5C")), /*#__PURE__*/React.createElement("text", {
    x: 420,
    y: 962,
    fontSize: 38,
    fontWeight: 900,
    fill: "#11117c",
    letterSpacing: 1
  }, "\u5168\u5458AI\u57FA\u7840\u80FD\u529B\uFF1A\u524D\u54E8 AI \u80DC\u4EFB\u529B\u6A21\u578B"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "font"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#bubbleShadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1148,
    y: 253,
    width: 183,
    height: 57,
    rx: 28.5,
    fill: "url(#pill)"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1239,
    y: 289,
    textAnchor: "middle",
    fontSize: 24,
    fontWeight: 900,
    fill: "#ffffff"
  }, "\u56DB\u9636\u6210\u719F\u5EA6")), /*#__PURE__*/React.createElement("line", {
    x1: 1170,
    y1: 333,
    x2: 1170,
    y2: 904,
    stroke: "#b3a0ff",
    strokeWidth: 3,
    opacity: 0.72
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1170,
    y1: 333,
    x2: 1170,
    y2: 904,
    stroke: "#ffffff",
    strokeWidth: 1,
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bubbleShadow)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 408,
    r: 10,
    fill: "#673aea",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 539,
    r: 10,
    fill: "#673aea",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 670,
    r: 10,
    fill: "#673aea",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1170,
    cy: 801,
    r: 10,
    fill: "#673aea",
    stroke: "#ffffff",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 409,
    r: 31,
    fill: "url(#nodeBubble)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-rising",
    x: 1204,
    y: 383,
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 539,
    r: 31,
    fill: "url(#nodeBubble)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-network",
    x: 1204,
    y: 513,
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 670,
    r: 31,
    fill: "url(#nodeBubble)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-bars",
    x: 1204,
    y: 644,
    width: 52,
    height: 52
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1230,
    cy: 801,
    r: 31,
    fill: "url(#nodeBubble)"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#i-user",
    x: 1204,
    y: 775,
    width: 52,
    height: 52
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 400,
    className: "right-title"
  }, "\u91CD\u6784\u671F"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 433,
    className: "right-copy"
  }, "\u91CD\u5851\u4E1A\u52A1\u4E0E\u7EC4\u7EC7"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 531,
    className: "right-title"
  }, "\u6269\u6563\u671F"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 564,
    className: "right-copy"
  }, "\u89C4\u6A21\u5316\u590D\u5236\u4E0E\u6269\u5C55"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 662,
    className: "right-title"
  }, "\u60EF\u7528\u671F"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 695,
    className: "right-copy"
  }, "\u7A33\u5B9A\u5E94\u7528\u4E0E\u4F18\u5316"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 793,
    className: "right-title"
  }, "\u521D\u7528\u671F"), /*#__PURE__*/React.createElement("text", {
    x: 1275,
    y: 826,
    className: "right-copy"
  }, "\u63A2\u7D22\u5C1D\u8BD5\u4E0E\u5E94\u7528")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadershipLadder);
export default __webpack_public_path__ + "static/media/leadership-ladder.0a520dc3dba4443a8aa96b157f3a10d5.svg";
export { ForwardRef as ReactComponent };